module.exports = __webpack_public_path__ + "static/media/fleetdriverIcon.2dac244d.svg";